module.exports = __webpack_public_path__ + "img/learn-basque.c6f24a66.png";